function waitForElement(selector, trigger, delayInterval, delayTimeout) {
  var interval = setInterval(function() {
    if (
      document &&
      document.querySelector(selector) &&
      document.querySelectorAll(selector).length > 0
    ) {
      clearInterval(interval);
      trigger();
    }
  }, delayInterval);
  setTimeout(function() {
    clearInterval(interval);
  }, delayTimeout);
}

// collapsed filter
waitForElement('.boost-pfs-filter-options-wrapper', filterCheck, 500, 5000);

function filterCheck() {
  document.querySelectorAll('.bm-collection .boost-pfs-filter-options-wrapper .boost-pfs-filter-option-title .boost-pfs-filter-option-title-heading').forEach(function(title, index) {
    if (index) {
      title.click();
    }
  });
}

// Text change for Refine By
waitForElement('.bm-mobile-toolbar .boost-pfs-filter-tree-mobile-button-label', filterTextchange, 500, 5000);

function filterTextchange() {
  $('.bm-mobile-toolbar .boost-pfs-filter-tree-mobile-button-label').text("FILTER");
}
waitForElement('.bm-collection .boost-pfs-filter-mobile-toolbar-header', filterTextchangePopup, 500, 5000);

function filterTextchangePopup() {
  $('.bm-collection .boost-pfs-filter-mobile-toolbar-header').text("FILTER BY");
}

// ATC button text update
waitForElement('.bm-collection .boost-pfs-addtocart-btn-text', ATCTextchange, 500, 5000);

function ATCTextchange() {
  $('.bm-collection .boost-pfs-addtocart-btn-text').text("Add to Cart");
}

// collection banner slider activet
document.addEventListener('DOMContentLoaded', function() {
  if(typeof Splide != 'undefined') {
    new Splide('#main-carousel', {
      type: 'loop',
      perPage: 4,
      pagination: false,
      gap: '20px',
      perMove: 1,
    }).mount();
  }
});

$(document).ready(function() {
  // show description
  $('.bm-collection-description .bm-readmore').on('click', function() {
    $(this).toggleClass("bmshowdesc");
    $('#bmsingleDescription').toggleClass("bmhidedescription");
    $('#bmfullDescription').toggleClass("bmshowdescription");

    if ($(this).hasClass("bmshowdesc")) {
      $(this).html("Read Less Description<span></span>");
    } else {
      $(this).html("Read Full Description<span></span>");
    }
  });

  $('body').on('change', '.new-collection-options select', function() {
    var href = $(this).parent().prev('a.boost-pfs-filter-product-item-title').attr('href');
    if (href.indexOf('?variant=') > -1) {
      href = href.split('?')[0] + '?variant=' + $(this).val();
    } else {
      href += '?variant=' + $(this).val();
    }
    $(this).parent().prev('a.boost-pfs-filter-product-item-title').attr('href', href);
    $(this).parents('.boost-pfs-filter-product-item').find('a.boost-pfs-filter-product-item-image-link').attr('href', href);
    // window.location.href = href;
    var price = $(this).children('option:selected').attr('data-price');
    var compare_at_price = $(this).children('option:selected').attr('data-compare_at_price');
    if (compare_at_price == 'null') {
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-regular-price').html('$' + price);
    } else {
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-sale-price').html('$' + price);
      $(this).parents('.boost-pfs-filter-product-item').find('.boost-pfs-filter-product-item-price s').html('$' + compare_at_price);
    }
  });
});

// Faq Content 
var bmFaq = $(".bm-faq-content h3");
var i;

for (i = 0; i < bmFaq.length; i++) {
  bmFaq[i].addEventListener("click", function() {
    this.classList.toggle("bm-faq-content-tab");

    var BmFaqDes = this.nextElementSibling;
    if (BmFaqDes.style.display === "block") {
      BmFaqDes.style.display = "none";
    } else {
      BmFaqDes.style.display = "block";
    }
  });
}
